<template>
    <div>
        <div class="pagetitle">
            <h1>Complaint</h1>
            <nav>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Home</li>
                    <li class="breadcrumb-item">Forms</li>
                    <li class="breadcrumb-item active">Complaint</li>
                </ol>
            </nav>
        </div>
        <div class="col text-left">
            <a href="#" class="btn btn-sm btn-primary shadow-sm" data-toggle="modal" data-target="#tambahComplaint">
                <i class="bi bi-plus fa-sm text-white-50"></i>Tambah Complaint
            </a>
        </div>
        <br>
        <div class="row mb-3">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Complaint</h5>
                        <div>
                            <label for="searchQuery" class="form-label">Search:</label>
                            <input type="text" class="form-control mb-3" id="searchQuery" v-model="searchQuery" @change="getComplaint" placeholder="Search...">
                            <div class="form-group mb-3 d-inline-block mr-3">
                                <label for="pageSize" class="form-label">Items per page:</label>
                                <select name="pageSize" id="pageSize" class="form-select" v-model="pageSize" @change="getComplaint">
                                    <option v-for="size in sizes" :key="size" :value="size">
                                        {{ size }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group mb-3 d-inline-block">
                                <a href="#" class="btn btn-sm btn-success shadow-sm" @click="downloadComplaintList">
                                    <i class="bi bi-download fa-sm text-white-50"></i> Download Data
                                </a>
                            </div>
                            <table class="table table-striped table-hover">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">No</th>
                                        <th scope="col">Nama & Asal Perusahaan</th>
                                        <th scope="col">Kontak</th>
                                        <th scope="col">Permasalahan</th>
                                        <th scope="col">Bukti</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Opsi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(complaint, index) in filteredComplaint" :key="index">
                                        <th scope="row">{{ index + 1 + (currentPage - 1) * pageSize }}</th>
                                        <td>
                                            <strong>Nama:</strong> {{ complaint.name_complainer }}
                                            <br>
                                            <strong>Asal Perusahaan:</strong> {{ complaint.name_company }}
                                        </td>
                                        <td>
                                            <strong>E-mail:</strong> {{ complaint.email }}
                                            <br>
                                            <strong>No. Handphone:</strong>{{ complaint.no_hp }}
                                        </td>
                                        <td>
                                            <strong>Subject:</strong> {{ complaint.subject }}
                                            <br>
                                            <strong>Deskripsi:</strong> {{ complaint.deskripsi }}
                                        </td>
                                         <td>
                                            <a :href="complaint.bukti" target="_blank" class="btn btn-sm btn-outline-info shadow-sm">
                                                <i class="bi bi-eye fa-sm text-dark"></i> Lihat Bukti
                                            </a>
                                        </td>
                                        <td>
                                            <span v-if="complaint.status === null || complaint.status === ''" style="color: #343A40;">
                                                <i class="bi bi-hourglass-split"></i> New
                                            </span>
                                            <span v-else-if="complaint.status === 4" style="color: #6495ED;">
                                                <i class="bi bi-arrow-right-circle-fill"></i> Re-Asign
                                            </span>
                                            <span v-else-if="complaint.status === 3" style="color: #0d6efd;">
                                                <i class="bi bi-play-circle-fill"></i> Started
                                            </span>
                                            <span v-else-if="complaint.status === 2" style="color: #ffc107;">
                                                <i class="bi bi-arrow-repeat"></i> In Progress
                                            </span>
                                            <span v-else-if="complaint.status === 1" style="color: #198754;">
                                                <i class="bi bi-check-circle-fill"></i> Done
                                            </span>
                                            <span v-else style="color: #dc3545;">
                                                <i class="bi bi-x-circle-fill"></i> Rejected
                                            </span>
                                        </td>
                                        <td style="text-align: center;">
                                            <a href="#" class="btn btn-sm btn-outline-primary shadow-sm" style="margin-right: 5px" @click="showModal('detail', complaint.id)">
                                                <i class="bi bi-info-circle fa-sm text-dark"></i>
                                            </a>
                                            <a href="#" class="btn btn-sm btn-outline-warning shadow-sm" style="margin-right: 5px" @click="showModal('edit', complaint.id)">
                                                <i class="bi bi-pencil-square fa-sm text-dark"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul class="pagination justify-content-center" @change="getComplaint">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                                    </li>
                                    <li v-if="showStartEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li
                                        class="page-item"
                                        v-for="page in displayedPages"
                                        :key="page"
                                        :class="{ active: currentPage === page }"
                                    >
                                        <button class="page-link" @click="changePage(page)">{{ page }}</button>
                                    </li>
                                    <li v-if="showEndEllipsis" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === pages }">
                                        <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === pages">Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Tambah -->
        <div class="modal fade" id="tambahComplaint" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tambahSuratModalLabel">Complaint Forms</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="addComplaint" enctype="multipart/form-data" :headers="{ 'Content-Type': 'multipart/form-data' }">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="nama" placeholder="nama" v-model="complaint.name_complainer">
                                    <label for="nama">Nama Complaint</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="company" placeholder="company" v-model="complaint.name_company">
                                    <label for="company">Asal Perusahaan</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="email" placeholder="E-mail" v-model="complaint.email">
                                    <label for="email">Email</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="no_hp" placeholder="No. Handphone" v-model="complaint.no_hp">
                                    <label for="no_hp">No. Handphone</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="subject" placeholder="Subject" v-model="complaint.subject">
                                    <label for="subject">Subject</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <textarea class="form-control" placeholder="Deskripsi" id="deskripsi" style="height: 150px;" v-model="complaint.deskripsi"></textarea>
                                    <label for="deskripsi">Deskripsi</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="bukti">Bukti</label>
                                    <div class="input-group">
                                        <div class="custom-file">
                                            <input 
                                                type="file" 
                                                class="custom-file-input" 
                                                id="bukti" 
                                                @change="handleFileUpload($event, 'bukti')" 
                                                accept=".png, .jpg, .jpeg, .pdf"
                                            >
                                            <label class="custom-file-label" for="bukti">{{ buktiName }}</label>
                                        </div>
                                    </div>
                                    <div v-if="buktiUrl != ''" class="mt-3">
                                        <img 
                                            v-if="typeof buktiName === 'string' && buktiName.match(/\.(png|jpg|jpeg)$/i)" 
                                            :src="buktiUrl" 
                                            class="img-thumbnail" 
                                            style="max-width: 200px;"
                                        >
                                        <embed 
                                            v-else 
                                            :src="buktiUrl" 
                                            type="application/pdf" 
                                            width="100%" 
                                            height="500px"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button type="button" class="btn btn-warning" @click="showRecaptcha">Verifikasi <i class="bi bi-shield-lock"></i></button>
                            </div>
                            <!-- reCAPTCHA -->
                            <div v-if="isRecaptchaVisible" class="mt-3 d-flex justify-content-center">
                                <div class="g-recaptcha" data-sitekey="6LfRUf8qAAAAAC63hlnC4ozvaul5QxOCrPoG0oK5" data-callback="onRecaptchaSuccess"></div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button> ||
                                <button type="reset" class="btn btn-secondary" @click="resetForm">Reset</button>
                            </div>
                        </form><!-- End floating Labels Form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Detail  -->
        <div ref="detailComplaintModal" class="modal fade" id="detailComplaint" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailComplaintModalLable">Detail Complaint</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <dl class="row">
                                        <dt class="col-sm-5">Nama Complaint</dt>
                                        <dd class="col-sm-7">{{ complaint.name_complainer }}</dd>
                                        <dt class="col-sm-5">Asal Perusahaan</dt>
                                        <dd class="col-sm-7">{{ complaint.name_company }}</dd>
                                        <dt class="col-sm-5">Email</dt>
                                        <dd class="col-sm-7">{{ complaint.email }}</dd>
                                        <dt class="col-sm-5">No. Handphone</dt>
                                        <dd class="col-sm-7">{{ complaint.no_hp }}</dd>
                                        <dt class="col-sm-5">Bukti</dt>
                                        <div v-if="complaint.bukti.match(/\.(png|jpg|jpeg|pdf)$/i)">
                                            <div v-if="complaint.bukti.match(/\.(png|jpg|jpeg)$/i)">
                                                <a :href="complaint.bukti" target="_blank">
                                                    <img :src="complaint.bukti" class="img-thumbnail" style="max-width: 200px;">
                                                </a>
                                            </div>
                                            <div v-else>
                                                <embed :src="complaint.bukti" type="application/pdf" width="100%" height="500px" />
                                            </div>
                                        </div>  
                                        <dt class="col-sm-5">Subject</dt>
                                        <dd class="col-sm-7">{{ complaint.subject }}</dd>
                                        <dt class="col-sm-5">Deskripsi</dt>
                                        <dd class="col-sm-7">{{ complaint.deskripsi }}</dd>
                                        <dt class="col-sm-5">Tanggal</dt>
                                        <dd class="col-sm-7">{{ complaint.created_on }}</dd>
                                        <dt class="col-sm-5">Status</dt>
                                        <dd class="col-sm-7">
                                            <span v-if="complaint.status === null || complaint.status === ''" style="color: #343A40;">
                                                <i class="bi bi-hourglass-split"></i> New
                                            </span>
                                            <span v-else-if="complaint.status === 4" style="color: #6495ED;">
                                                <i class="bi bi-arrow-right-circle-fill"></i> Re-Asign
                                            </span>
                                            <span v-else-if="complaint.status === 3" style="color: #0d6efd;">
                                                <i class="bi bi-play-circle-fill"></i> Started
                                            </span>
                                            <span v-else-if="complaint.status === 2" style="color: #ffc107;">
                                                <i class="bi bi-arrow-repeat"></i> In Progress
                                            </span>
                                            <span v-else-if="complaint.status === 1" style="color: #198754;">
                                                <i class="bi bi-check-circle-fill"></i> Done
                                            </span>
                                            <span v-else style="color: #dc3545;">
                                                <i class="bi bi-x-circle-fill"></i> Rejected
                                            </span>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="text-center">
                                <button class="btn btn-secondary" @click="closeModal"> Close </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Edit -->
        <div class="modal fade" id="editComplaint" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="editComplaintModalLabel">Edit Complaint</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" @submit.prevent="updateComplaint">
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="id" placeholder="id" v-model="selectedComplaint.updated_by" readonly>
                                    <label for="id">ID User</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="name" placeholder="name" v-model="selectedComplaint.updated_by_name" readonly>
                                    <label for="name">Nama User</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="nama" placeholder="nama" v-model="complaint.name_complainer" readonly>
                                    <label for="nama">Nama Complaint</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="company" placeholder="company" v-model="complaint.name_company" readonly>
                                    <label for="company">Asal Perusahaan</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="email" placeholder="E-mail" v-model="complaint.email" readonly>
                                    <label for="email">Email</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="no_hp" placeholder="No. Handphone" v-model="complaint.no_hp" readonly>
                                    <label for="no_hp">No. Handphone</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <input type="text" class="form-control" id="subject" placeholder="Subject" v-model="complaint.subject" readonly>
                                    <label for="subject">Subject</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-floating">
                                    <textarea class="form-control" placeholder="Deskripsi" id="deskripsi" style="height: 150px;" v-model="complaint.deskripsi" readonly></textarea>
                                    <label for="deskripsi">Deskripsi</label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="bukti">Bukti</label>
                                    <div v-if="complaint.bukti.match(/\.(png|jpg|jpeg|pdf)$/i)">
                                        <div v-if="complaint.bukti.match(/\.(png|jpg|jpeg)$/i)">
                                            <a :href="complaint.bukti" target="_blank">
                                                <img :src="complaint.bukti" class="img-thumbnail" style="max-width: 200px;">
                                            </a>
                                        </div>
                                        <div v-else>
                                            <embed :src="complaint.bukti" type="application/pdf" width="100%" height="500px" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="form-floating">
                                    <select class="form-select" name="status" id="status" v-model="complaint.status"  @change="handleStatusChange">
                                        <option :value="4">
                                            <i class="bi bi-arrow-right-circle-fill"></i> Re-Asign
                                        </option>
                                        <option :value="3">
                                            <i class="bi bi-play-circle-fill"></i> Start
                                        </option>
                                        <option :value="2">
                                            <i class="bi bi-arrow-repeat"></i> In Progress
                                        </option>
                                        <option :value="1">
                                            <i class="bi bi-check-circle-fill"></i> Done
                                        </option>
                                        <option :value="0">
                                            <i class="bi bi-x-circle-fill"></i> Rejected
                                        </option>
                                    </select>
                                    <label for="status">Status</label>
                                </div>
                            </div>
                            <div class="text-center">
                                <button type="submit" class="btn btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</template>
<script>
import complaintjs from './jsComplaint/complaint';
export default complaintjs;
</script>